<template>
  <v-container>
    <material-card>
      <v-layout px-3 slot="header">
        <v-flex my-4 pl-4 title align-center justify-center>Kategorie</v-flex>

        <v-spacer></v-spacer>

        <v-flex>
          <v-text-field
            prepend-icon="mdi-magnify"
            name="search"
            label="Wyszukaj"
            color="white"
            clearable
            v-model="search"
          ></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout text-xs-right>
        <v-flex>
          <check-permission permissions="CATEGORY.ADD">
            <v-btn large color="error" @click="showAddModal">DODAJ KATEGORIĘ</v-btn>
          </check-permission>
        </v-flex>
      </v-layout>

      <material-table
        editPerm="CATEGORY.UPDATE"
        deletePerm="CATEGORY.DELETE"
        :headers="table.headers"
        :items="list"
        :actions="true"
        :hideActions="false"
        :total-count="count"
        :search="search"
        @pagination="reloadList"
        @add="showAddModal"
        @edit="showEditModal"
        @delete="showDeleteDialog"
      ></material-table>

      <material-dialog
        title="Potwierdź usunięcie"
        text="Czy napewno chcesz usunąć kategorię?"
        :show="!!idToDelete"
        :id="idToDelete"
        @close="hideDeleteDialog"
        @confirm="remove"
      ></material-dialog>
    </material-card>

    <modal
      :show="showModal"
      :id="idToEdit"
      :edit="!!idToEdit"
      @close="hideModal"
      @save="addCategory"
      @update="updateCategory"
    ></modal>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';

import MaterialCard from '@/components/material/Card';
import MaterialDialog from '@/components/material/Dialog';
import MaterialTable from '@/components/material/Table';
import Modal from './addCategory.modal';
import { listMixin } from '@/mixins/list';

// @vuese
// Wyświetlanie listy kategorii
// @group Categories
export default {
  mixins: [
    listMixin('categories', {
      listError: 'Wystąpił błąd podczas pobierania listy kategorii.',
      getError: 'Wystąpił błąd podczas pobierania danych kategorii.',
      added: 'Dodano kategorię.',
      addError: 'Nie udało się dodać kategorii.',
      updated: 'Zaktualizowano dane kategorii.',
      updateError: 'Nie udało się zaktualizować danych kategorii.',
      deleted: 'Usunięto kategorię.',
      deleteError: 'Nie udało się usunąć kategorii.'
    })
  ],
  components: {
    MaterialCard,
    MaterialDialog,
    MaterialTable,
    Modal
  },
  methods: {
    // @vuese
    // Dodaje kategorię
    addCategory(data) {
      this.add({ category: { name: data.name } });
    },
    // @vuese
    // Aktualizuje kategorię
    updateCategory(data) {
      this.update({ category: { name: data.name }, id: data.id });
    }
  },

  data() {
    return {
      search: '',
      table: {
        headers: [{ value: 'name', text: 'Nazwa kategorii', sortable: true }]
      }
    };
  }
};
</script>
